import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const getAllUrls = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/reports/monitoring-urls', options);
};

const getUrlById = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/reports/monitoring-urls/' + dataClientId, options);
};

const createUrl = dataClient => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/reports/monitoring-urls', dataClient, options);
};

const updateUrl = (dataClient, dataClientId) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.put(NERTHUS + '/reports/monitoring-urls/' + dataClientId, dataClient, options);
};

const deleteUrl = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.delete(NERTHUS + '/reports/monitoring-urls/' + dataClientId, options);
};

const syncUrls = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/reports/monitoring-urls/create-prometheus-targets-file', {}, options);
};

const MonitorUrlCrudService = {
  getAllUrls,
  getUrlById,
  createUrl,
  updateUrl,
  deleteUrl,
  syncUrls
};

export default MonitorUrlCrudService;